import { usePanelWidth } from './usePanelWidth';

const ARTIFACT_PANEL_CONFIG = {
  storageKey: 'artifactPanelWidth',
  defaultWidth: 755,
  minWidth: 755,
  minContentWidth: 700, // Minimum width for chat area + buffer for sidebar
};

export const useArtifactPanelWidth = () => {
  return usePanelWidth(ARTIFACT_PANEL_CONFIG);
};
